import { Controller } from '@hotwired/stimulus'
import Modal from 'components/modal'

export default class ModalOpenOnLoad extends Controller {
  static targets = [ "useHtmx" ]

  initialize() {
    if (this.hasUseHtmxTarget) {
      this._loadFromHtmxSwap()
    } else {
      Modal.show(this.modalId = this.element.id)
    }
  }

  _loadFromHtmxSwap() {
    let modalShown = false

    // Allows Modal open on load to automatically show after HX Swap settles
    document.addEventListener("htmx:afterSettle", () => {
      if (!modalShown) {
        Modal.show(this.modalId = this.element.id)
        modalShown = true
      }
    })
  }
}
